import{gql as o}from"@apollo/client";import{usePlatformLazyQuery as t}from"../../core/hooks/use-platform-lazy-query.hook.js";import{COMPONENT_TRANSLATION_KEY_PREFIX as a}from"../constants/component-translation-key-prefix.constant.js";const e=o`
  query getTranslation($locales: [String!]) {
    translationKeys(searchTerm: "${a}") {
      data {
        key
        translations(filter: { locale: { valueIn: $locales } }) {
          data {
            value
            locale
          }
        }
      }
      totalCount
    }
  }
`,l=()=>t(e,{fetchPolicy:"network-only",nextFetchPolicy:"no-cache"});export{l as usePlatformTranslations};